import { render, staticRenderFns } from "./GhostChallengeDetails.vue?vue&type=template&id=4249a111&scoped=true"
import script from "./GhostChallengeDetails.vue?vue&type=script&lang=js"
export * from "./GhostChallengeDetails.vue?vue&type=script&lang=js"
import style0 from "./GhostChallengeDetails.vue?vue&type=style&index=0&id=4249a111&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4249a111",
  null
  
)

export default component.exports